import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "danger" | "icon";
type ButtonSize = "default" | "small";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  loadingLabel?: ReactNode;
};

function variantClass(variant: ButtonVariant) {
  if (variant === "icon") return "icon-pill";
  return `${variant}-button`;
}

export function Button({
  variant = "primary",
  size = "default",
  loading = false,
  loadingLabel,
  className = "",
  disabled,
  children,
  type = "button",
  ...rest
}: ButtonProps) {
  const classes = [variantClass(variant), size === "small" ? "small" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {loading && loadingLabel != null ? loadingLabel : children}
    </button>
  );
}
